/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: '/control',
  name: 'control',
  children: [
    {
      path: '/',
      name: 'control-index',
      load: () => import(/* webpackChunkName: 'control' */ './default'),
    },
    {
      path: '/education',
      name: 'control-education',
      load: () => import(/* webpackChunkName: 'control' */ './education'),
    },
    {
      path: '/education/edit',
      name: 'control-education-edit',
      load: () => import(/* webpackChunkName: 'control' */ './education-edit'),
    },
    {
      path: '/list',
      name: 'control-list',
      load: () => import(/* webpackChunkName: 'control' */ './list'),
    },
    {
      path: '/list/edit',
      name: 'control-list-edit',
      load: () => import(/* webpackChunkName: 'control' */ './list-edit'),
    },
    {
      path: '/brands',
      name: 'control-brands',
      load: () => import(/* webpackChunkName: 'control' */ './brands'),
    },
    {
      path: '/distributors',
      name: 'control-distributors',
      load: () => import(/* webpackChunkName: 'control' */ './distributors'),
    },
    {
      path: '/config',
      name: 'control-config',
      load: () => import(/* webpackChunkName: 'control' */ './config'),
    },
    {
      path: '/config-edit',
      name: 'control-configedit',
      load: () => import(/* webpackChunkName: 'control' */ './config-edit'),
    },
    {
      path: '/content',
      name: 'control-content',
      load: () => import(/* webpackChunkName: 'control' */ './content'),
    },
    {
      path: '/content-edit',
      name: 'control-contentedit',
      load: () => import(/* webpackChunkName: 'control' */ './content-edit'),
    },
    {
      path: '/edit',
      name: 'control-edit',
      load: () => import(/* webpackChunkName: 'control' */ './edit'),
    },
    {
      path: '/groups',
      name: 'control-groups',
      load: () => import(/* webpackChunkName: 'control' */ './groups'),
    },
    {
      path: '/products',
      name: 'control-products',
      load: () => import(/* webpackChunkName: 'control' */ './products'),
    },
    {
      path: '/masterproducts',
      name: 'control-masterproducts',
      load: () => import(/* webpackChunkName: 'control' */ './masterproducts'),
    },
    // {
    //   path: '/kpis',
    //   name: 'control-kpis',
    //   load: () => import(/* webpackChunkName: 'control' */ './kpis'),
    // },
    // {
    //   path: '/reps',
    //   name: 'control-reps',
    //   load: () => import(/* webpackChunkName: 'control' */ './reps'),
    // },
    {
      path: '/sales',
      name: 'control-sales',
      load: () => import(/* webpackChunkName: 'control' */ './sales'),
    },
    // {
    //   path: '/salons',
    //   name: 'control-salons',
    //   load: () => import(/* webpackChunkName: 'control' */ './salons'),
    // },
    // {
    //   path: '/content-temp',
    //   name: 'control-contenttemp',
    //   load: () => import(/* webpackChunkName: 'control' */ './content-temp'),
    // },
    {
      path: '/filevault',
      name: 'control-filevault',
      load: () => import(/* webpackChunkName: 'control' */ './filevault'),
    },
    {
      path: '/filevault-edit',
      name: 'control-filevaultedit',
      load: () => import(/* webpackChunkName: 'control' */ './filevault-edit'),
    },
    {
      path: '/loyalty-bonus-points',
      name: 'loyalty-bonus-points',
      load: () =>
        import(/* webpackChunkName: 'control' */ './loyalty-bonus-points'),
    },
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('cmdctrl')) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }
    return next();
  },
};



// WEBPACK FOOTER //
// ./src/routes/client/site/control/index.js